import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.schedule');
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-schedule',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.schedule/view.scss */
:host {
  min-width: 0;
  container: page-schedule/inline-size;
  display: block;
  min-height: 100%;
  background: var(--wb-page-canvas, #f5f9fd);
  color: #142b3a;
}

.schedule-page {
  max-width: 92rem;
  margin: 0 auto;
  padding: 2rem;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.schedule-back {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #456578;
  font-size: 0.8rem;
  font-weight: 700;
}

.schedule-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  border: 1px solid #0864b8;
  border-radius: 0.65rem;
  background: #0967c2;
  padding: 0.55rem 1rem;
  color: #fff;
  font-size: 0.82rem;
  font-weight: 800;
}

.schedule-primary:hover {
  background: #0757a6;
}

.schedule-primary:disabled {
  opacity: 0.55;
  cursor: wait;
}

.schedule-alert, .schedule-form-error {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  border: 1px solid #fecaca;
  border-radius: 0.65rem;
  background: #fef2f2;
  padding: 0.75rem 1rem;
  color: #991b1b;
  font-size: 0.8rem;
}

.schedule-alert {
  margin-bottom: 1rem;
}

.schedule-alert button {
  text-decoration: underline;
  font-weight: 800;
}

.schedule-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 19rem;
  gap: 1rem;
  align-items: start;
}

.schedule-calendar, .schedule-day-panel {
  border: 1px solid #dce5eb;
  border-radius: 0.9rem;
  background: #fff;
  box-shadow: 0 3px 14px rgba(32, 71, 98, 0.04);
}

.schedule-calendar {
  overflow: hidden;
}

.schedule-calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.2rem;
  border-bottom: 1px solid #e3ebf0;
}

.schedule-calendar-header h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 850;
}

.schedule-nav {
  display: flex;
  gap: 0.35rem;
}

.schedule-nav button {
  min-width: 2.2rem;
  min-height: 2.2rem;
  border: 1px solid #dce5eb;
  border-radius: 0.5rem;
  background: #fff;
  padding: 0 0.55rem;
  color: #314b5b;
  font-size: 0.76rem;
  font-weight: 750;
}

.schedule-nav button:hover {
  background: #eef6fd;
}

.schedule-weekdays, .schedule-grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.schedule-weekdays span {
  padding: 0.65rem 0.5rem;
  text-align: center;
  background: #f5f8fa;
  color: #667d8b;
  font-size: 0.74rem;
  font-weight: 800;
}

.schedule-weekdays span:first-child {
  color: #c74747;
}

.schedule-day {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.25rem;
  min-width: 0;
  min-height: 7.5rem;
  border: 0;
  border-right: 1px solid #e6edf1;
  border-bottom: 1px solid #e6edf1;
  background: #fff;
  padding: 0.55rem;
  text-align: left;
}

.schedule-day:nth-child(7n) {
  border-right: 0;
}

.schedule-day:hover {
  background: #f3f9fe;
}

.schedule-day.is-outside {
  background: #f9fafb;
  color: #a0aeb7;
}

.schedule-day.is-selected {
  outline: 2px solid #0967c2;
  outline-offset: -2px;
  background: #f2f8ff;
}

.schedule-day-number {
  display: grid;
  place-items: center;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 50%;
  font-size: 0.8rem;
  font-weight: 800;
}

.schedule-day.is-today .schedule-day-number {
  background: #0967c2;
  color: #fff;
}

.schedule-calendar-event {
  overflow: hidden;
  border-radius: 0.35rem;
  background: #e5f3ff;
  padding: 0.2rem 0.35rem;
  color: #0b5b9a;
  font-size: 0.68rem;
  font-weight: 750;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.schedule-calendar-event.is-cancelled {
  background: #f1f3f5;
  color: #7b8992;
  text-decoration: line-through;
}

.schedule-day small {
  color: #5f788a;
  font-size: 0.68rem;
}

.schedule-loading {
  min-height: 32rem;
  display: grid;
  place-items: center;
  color: #647b8a;
  font-size: 0.85rem;
}

.schedule-day-panel {
  overflow: hidden;
}

.schedule-day-panel > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  border-bottom: 1px solid #e3ebf0;
  padding: 1rem;
}

.schedule-day-panel > header span {
  color: #687e8a;
  font-size: 0.68rem;
  font-weight: 750;
}

.schedule-day-panel h2 {
  margin: 0.1rem 0 0;
  font-size: 1rem;
  font-weight: 850;
}

.schedule-day-panel > header button {
  display: grid;
  place-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  background: #e8f3ff;
  color: #0967c2;
}

.schedule-empty {
  padding: 1.3rem 1rem;
  color: #71838e;
  font-size: 0.78rem;
  line-height: 1.6;
}

.schedule-agenda {
  margin: 0;
  padding: 0.45rem;
  list-style: none;
}

.schedule-agenda li + li {
  border-top: 1px solid #edf1f4;
}

.schedule-agenda button {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.2rem 0.4rem;
  width: 100%;
  padding: 0.7rem 0.6rem;
  border-radius: 0.45rem;
  text-align: left;
}

.schedule-agenda button:hover {
  background: #f3f9fe;
}

.schedule-agenda time {
  grid-column: 1/-1;
  color: #0b66ad;
  font-size: 0.75rem;
  font-weight: 850;
}

.schedule-agenda strong {
  font-size: 0.8rem;
}

.schedule-agenda span {
  color: #0f766e;
  font-size: 0.7rem;
  font-weight: 750;
}

.schedule-agenda small {
  grid-column: 1/-1;
  color: #70808a;
  font-size: 0.7rem;
  line-height: 1.5;
}

.schedule-agenda .is-cancelled {
  opacity: 0.6;
}

.schedule-agenda .is-cancelled span {
  color: #7b8992;
}

.schedule-dialog-backdrop {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  place-items: center;
  overflow-y: auto;
  background: rgba(15, 35, 48, 0.5);
  padding: 1rem;
}

.schedule-dialog {
  width: min(100%, 31rem);
  max-height: 100%;
  overflow-y: auto;
  border-radius: 0.95rem;
  background: #fff;
  padding: 1.4rem;
  box-shadow: 0 24px 60px rgba(14, 39, 56, 0.2);
}

.schedule-dialog > header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.schedule-dialog > header h2 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 850;
}

.schedule-dialog > header button {
  width: 2rem;
  height: 2rem;
  border-radius: 0.4rem;
  color: #536b7a;
}

.schedule-dialog > label, .schedule-form-row label {
  display: grid;
  gap: 0.4rem;
  margin-top: 0.9rem;
}

.schedule-dialog label span {
  color: #40596a;
  font-size: 0.75rem;
  font-weight: 800;
}

.schedule-dialog input, .schedule-dialog select, .schedule-dialog textarea {
  width: 100%;
  min-height: 2.55rem;
  border: 1px solid #cbd8e0;
  border-radius: 0.55rem;
  background: #fff;
  padding: 0.55rem 0.65rem;
  color: #183244;
  font-size: 0.82rem;
}

.schedule-dialog textarea {
  resize: vertical;
}

.schedule-dialog input:focus, .schedule-dialog select:focus, .schedule-dialog textarea:focus {
  border-color: #0967c2;
  outline: 3px solid rgba(9, 103, 194, 0.14);
}

.schedule-form-row {
  display: grid;
  grid-template-columns: 1.3fr 1fr 1fr;
  gap: 0.6rem;
}

.schedule-form-error {
  margin-bottom: 0.8rem;
}

.schedule-dialog footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.3rem;
}

.schedule-secondary, .schedule-danger {
  min-height: 2.55rem;
  border: 1px solid #cbd8e0;
  border-radius: 0.55rem;
  background: #fff;
  padding: 0.55rem 0.8rem;
  color: #40596a;
  font-size: 0.8rem;
  font-weight: 800;
}

.schedule-danger {
  margin-right: auto;
  border-color: #fecaca;
  color: #b91c1c;
}

.schedule-danger:hover {
  background: #fef2f2;
}

@container page-schedule (max-width: 950px) {
  .schedule-layout {
    grid-template-columns: 1fr;
  }
  .schedule-day-panel {
    order: -1;
  }
}
@container page-schedule (max-width: 640px) {
  .schedule-page {
    padding: 1rem;
  }
  .schedule-header {
    align-items: start;
  }
  .schedule-header h1 {
    font-size: 1.35rem;
  }
  .schedule-header > .schedule-primary {
    flex: 0 0 auto;
  }
  .schedule-day {
    min-height: 5.1rem;
    padding: 0.3rem;
  }
  .schedule-calendar-event {
    font-size: 0.6rem;
  }
  .schedule-form-row {
    grid-template-columns: 1fr 1fr;
  }
  .schedule-form-row label:first-child {
    grid-column: 1/-1;
  }
}`],
})
export class PageScheduleComponent implements OnInit {
    public month: string = '';
    public selectedDate: string = '';
    public today: string = '';
    public days: any[] = [];
    public appointments: any[] = [];
    public patients: any[] = [];
    public loading: boolean = true;
    public saving: boolean = false;
    public errorMessage: string = '';
    public formError: string = '';
    public csrfToken: string = '';
    public formOpen: boolean = false;
    public form: any = this.emptyForm();
    public weekdays: string[] = ['일', '월', '화', '수', '목', '금', '토'];

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        this.today = this.koreanToday();
        const date = String(this.route.snapshot.queryParamMap.get('date') || '');
        this.selectedDate = /^\d{4}-\d{2}-\d{2}$/.test(date) ? date : this.today;
        this.month = this.selectedDate.slice(0, 7);
        await this.load();
        const appointmentId = String(this.route.snapshot.queryParamMap.get('appointment') || '');
        if (/^[0-9a-f]{32}$/.test(appointmentId)) {
            const appointment = this.appointments.find((item: any) => item.id === appointmentId);
            if (appointment) this.openEdit(appointment);
        }
    }

    private koreanToday() {
        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const pick = (type: string) => parts.find((part: any) => part.type === type)?.value || '';
        return `${pick('year')}-${pick('month')}-${pick('day')}`;
    }

    private emptyForm(date: string = '') {
        return { id: '', patient_id: '', date: date || this.selectedDate || this.today,
            status: 'scheduled',
            start_time: '10:00', end_time: '11:00', note: '', row_version: 0 };
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        try {
            const { code, data } = await wiz.call('calendar', { month: this.month }, { cache: false });
            if (code !== 200) {
                this.errorMessage = data?.message || '일정을 불러오지 못했습니다.';
                return;
            }
            this.appointments = Array.isArray(data?.appointments) ? data.appointments : [];
            this.patients = Array.isArray(data?.patients) ? data.patients : [];
            this.csrfToken = data?.csrf_token || this.csrfToken;
            this.buildDays();
        } catch (error) {
            this.errorMessage = '일정을 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private buildDays() {
        const [year, month] = this.month.split('-').map(Number);
        const firstWeekday = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
        const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();
        const count = Math.ceil((firstWeekday + daysInMonth) / 7) * 7;
        this.days = Array.from({ length: count }, (_value, index) => {
            const date = new Date(Date.UTC(year, month - 1, index - firstWeekday + 1));
            const value = date.toISOString().slice(0, 10);
            return {
                date: value,
                day: date.getUTCDate(),
                inMonth: value.slice(0, 7) === this.month,
                appointments: this.appointments.filter((item: any) => item.date === value)
            };
        });
    }

    public monthLabel() {
        const [year, month] = this.month.split('-');
        return `${year}년 ${Number(month)}월`;
    }

    public async moveMonth(delta: number) {
        const [year, month] = this.month.split('-').map(Number);
        this.month = new Date(Date.UTC(year, month - 1 + delta, 1)).toISOString().slice(0, 7);
        this.selectedDate = this.month === this.today.slice(0, 7) ? this.today : `${this.month}-01`;
        this.formOpen = false;
        await this.load();
    }

    public async goToday() {
        this.today = this.koreanToday();
        this.month = this.today.slice(0, 7);
        this.selectedDate = this.today;
        this.formOpen = false;
        await this.load();
    }

    public async selectDay(day: any) {
        if (!day?.inMonth) {
            this.month = String(day.date).slice(0, 7);
            await this.load();
        }
        this.selectedDate = day.date;
        this.formOpen = false;
        await this.service.render();
    }

    public selectedAppointments() {
        return this.appointments.filter((item: any) => item.date === this.selectedDate);
    }

    public selectedDateLabel() {
        const [year, month, day] = this.selectedDate.split('-').map(Number);
        return `${year}년 ${month}월 ${day}일`;
    }

    public openNew(date: string = this.selectedDate) {
        this.form = this.emptyForm(date);
        this.formError = '';
        this.formOpen = true;
        void this.service.render();
    }

    public openEdit(appointment: any) {
        this.selectedDate = appointment.date;
        this.form = { id: appointment.id, patient_id: appointment.patient_id,
            date: appointment.date, start_time: appointment.start_time,
            end_time: appointment.end_time, note: appointment.note || '', status: appointment.status,
            row_version: appointment.row_version };
        this.formError = '';
        this.formOpen = true;
        void this.service.render();
    }

    public closeForm() {
        this.formOpen = false;
        this.formError = '';
        void this.service.render();
    }

    public async save() {
        if (this.saving) return;
        this.formError = '';
        if (!this.form.patient_id || !this.form.date || !this.form.start_time || !this.form.end_time) {
            this.formError = '환자와 날짜, 시작·종료 시간을 입력해주세요.';
            await this.service.render();
            return;
        }
        if (this.form.end_time <= this.form.start_time) {
            this.formError = '종료 시간은 시작 시간보다 늦어야 합니다.';
            await this.service.render();
            return;
        }
        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', { ...this.form, csrf_token: this.csrfToken });
            if (code !== 200) {
                this.formError = data?.message || '일정을 저장하지 못했습니다.';
                return;
            }
            this.selectedDate = this.form.date;
            this.month = this.form.date.slice(0, 7);
            this.formOpen = false;
            await this.load();
        } catch (error) {
            this.formError = '일정을 저장하지 못했습니다.';
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async cancelAppointment() {
        if (!this.form.id || this.saving || !window.confirm('이 치료 일정을 취소할까요?')) return;
        this.saving = true;
        this.formError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('cancel', {
                id: this.form.id, row_version: this.form.row_version, csrf_token: this.csrfToken
            });
            if (code !== 200) {
                this.formError = data?.message || '일정을 취소하지 못했습니다.';
                return;
            }
            this.formOpen = false;
            await this.load();
        } catch (error) {
            this.formError = '일정을 취소하지 못했습니다.';
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public trackByDate(_index: number, item: any) { return item.date; }
    public trackById(_index: number, item: any) { return item.id; }
}

export default PageScheduleComponent;